import React, { Component } from 'react';
import { isEmpty, isEqual, orderBy } from 'lodash';
import {
  Carousel,
  UploadImageModal,
  Loading
} from "common-import/custom";

import { VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";
import v from "voca";
import moment from "moment";

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

const Text = [
  "name",
  "description",
  "unitWeight",
  "unitWidth",
  "unitDepth",
  "inventorySKU",
  "inventoryBarcode",
  "inventoryPolicy",
  "brand",
  "shipping",
  "shipsTo"
];

const Number = [
  "price",
  "comparePrice",
  "minDepth",
  "maxDepth",
  "minWeight",
  "maxWeight",
  "minWidth",
  "maxWidth",
  "numberOfSell",
  "sale"
];

const Boolean = [
  "isChargeTaxes",
  "isRequireShip",
  "isNewArrived"
];

const Select = [
  "category",
  "subCategory",
  "subSubCategory",
  "productType"
];

const ListType = [
  "tags",
  "styles",
  "colors",
  "sizes",
  "variants",
  "materials",
  "collections"
];

const propertyProduct = [...Text, ...Number, ...Boolean, ...Select, ...ListType];

@inject("productStore", "userStore", "masterStore", "ratingStore", "routeStore") @observer
export default class ProductDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: {},
      current: {},
      isSaving: false,
      enableEdit: false,
      isLoading: true,
      openImageModal: false,
      isDeleting: false,
      isApproving: false,
      reviewList: [],
      reviewListBackup: [],
      review: {},
      enableAddNew: false,
      isAdding: false,
    }
  }
  async componentDidMount() {
    const { productStore, userStore, match } = this.props;
    await userStore.onReady();
    const res = await productStore.detail(match.params.id);
    this.setState({isLoading: false});
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    this.setState({product: res.data, current: res.data});
    await this.getRatingList();
  };

  getRatingList = async () => {
    const { ratingStore, match } = this.props;
    const res = await ratingStore.getList({objectId: match.params.id});
    if (!!res.error) return window.toast.error("Can not get rating: " + JSON.stringify(res.error));
    this.setState({reviewList: res.data, reviewListBackup: res.data});
  };

  approveProject = async e => {
    !!e && e.preventDefault();
    const { productStore, match } = this.props;
    const { current } = this.state;
    const continueApprove = window.confirm("Are you sure want to approve this project?");
    if(continueApprove) {
      this.setState({isApproving: true});
      let result = await productStore.approve({ id: match.params.id, approved: true });
      this.setState({isApproving: false});
      if (!!result.error) return window.toast.error(JSON.stringify(result.error));
      current.approved = 1;
      this.setState({product: current, current});
      return window.toast.info("Approved successfully.");
    }
  };

  deleteProject = async e => {
    !!e && e.preventDefault();
    const { productStore, match } = this.props;
    const { current } = this.state;
    const continueApprove = window.confirm("Are you sure want to DELETE this product?");
    if (continueApprove) {
      this.setState({isDeleting: true});
      let result = await productStore.delete({id: match.params.id, ownerId: current.ownerId});
      this.setState({isDeleting: false});
      if (!!result.error) return window.toast.error(JSON.stringify(result.error));
      return window.toast.info("DELETED successfully.");
    }
  };

  renderApprove = () => {
    const { isApproving, isDeleting } = this.state;
    const { approved } = this.state.current;
    if (approved === undefined || approved === "" || approved === true || approved === 1) {
      return (
        <div className="approve-request-section">
          <button className="btn btn-sm btn-danger" disabled={isDeleting} onClick={e => this.deleteProject(e)}>
            <i className="fa fa-dot-circle-o"> </i> {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      )
    }
    return (
      <div className="approve-request-section">
        <button className="btn btn-sm btn-primary" disabled={isApproving} onClick={e => this.approveProject(e)}>
          <i className="fa fa-dot-circle-o"> </i> {isApproving ? 'Approving...' : 'Approve'}
        </button>
      </div>
    )
  };

  formatPayload = (data) => {
    let copy;

    const typeFormat = {
      typeArray: ["images", "variants", "sizes", "colors", "materials", "tags", "styles", "collections"],
      typeBoolean: ["isChargeTaxes", "isRequireShip", "isNewArrived"],
      typeNumber: ["price", "comparePrice", "minDepth", "maxDepth", "minWeight", "maxWeight", "minWidth", "maxWidth", "sale"],
      typeString: ["id", "name", "description", "category", "subCategory", "subSubCategory", "unitWeight", "unitWidth", "unitDepth", "inventorySKU", "inventoryBarcode", "inventoryPolicy", "productType", "vendor", "brand", "shipping", "shipsTo"]
    };

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }

    copy = VarHelper.copyObjectWithKey(keyList, data);
    return VarHelper.formatValueByType(copy, typeFormat);
  };

  handleEnableEdit = (e) => {
    e.preventDefault();
    this.setState({ enableEdit: true })
  };

  handleCloseModal = () => {
    this.setState({
      openImageModal: false,
    });
  };

  handleOpenModal = () => {
    this.setState({
      openImageModal: true,
    });
  };

  handleSubmitModal = async (list) => {
    const { current } = this.state;
    this.setState({ current: {...current, images: [...list]} });
    this.handleCloseModal();
  };

  cancelEdit = (e) => {
    e.preventDefault();
    const { product, current } = this.state;

    if (!isEqual(current, product)) {
      if (!window.confirm('Are you sure want to cancel the changes?')) {
        return null;
      }
      this.setState({
        enableEdit: false,
        current: product,
      })
    }
    this.setState({ enableEdit: false });
  };

  saveChanges = async () => {
    const { productStore, match } = this.props;
    const { current } = this.state;
    const payload = this.formatPayload(current);

    this.setState({ isSaving: true });
    const res = await productStore.update(payload);
    this.setState({ isSaving: false });

    if (!!res.error) return window.toast.error(JSON.stringify(res.error));

    this.setState({
      project: res.data,
      current: res.data
    });

    window.toast.info('Updated successfully.');

    const resApprove = await productStore.approve({ id: match.params.id, approved: true });
    if (!resApprove.error) {
      this.setState({
        product: {...this.state.current, approved: 1},
        current: {...this.state.current, approved: 1},
      });
    }
  };

  renderCreator = () => {
    const { current } = this.state;
    if (current.hasOwnProperty('createdByUser')) {
      const creator = current.createdByUser || {};
      return (
        <div className="block-content">
          <h4 className="block-content__title">Creator</h4>
          <div className="media user">
            <div className="media-left user-avatar"
                 style={{ backgroundImage: `url(${VarHelper.img(creator.avatar) || defaultImage})` }}>
            </div>
            <div className="media-body">
              <h4 className="media-heading">{creator.name}</h4>
              <p className="user__phone">
                <i className="fa fa-phone-square" aria-hidden="true"> </i> {creator.phone}
              </p>
              <p className="user__email">
                <i className="fa fa-envelope" aria-hidden="true"> </i> {creator.email}
              </p>
              <p className="user__created-date">
                <strong>Created at:</strong> {moment(current.createdAt).format('LL')}
              </p>
              <p className="user__update-date">
                <strong>Last update:</strong> {moment(current.updatedAt).format('LL')}
              </p>
            </div>
          </div>
        </div>
      )
    }
  };

  renderUploadForm = () => {
    const { current } = this.state;
    return (
      <div className="block-content">
        <div className="block-content__title">
          <span><i className="fa fa-file"> </i> Images</span>
        </div>
        <div className="block-content__body">
          {/*images*/}
          <label>Images ({(current.images || []).length})</label>
          <div className="input-group" style={{marginBottom:'16px'}}>
            <input type="text" disabled={true} className="form-control"
                   value={!!current.images ? current.images.join(', ') : ''}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('image')}>Edit</button>
            </div>
          </div>
        </div>
      </div>
    )
  };

  renderFormEdit() {
    const {
      toSelectData,
      product_categories,
      product_categories_lev3,
      product_sub_categories,
      product_type
    } = this.props.masterStore;

    const yesNoSelect = [
      {id: 0, label: 'No', value: 'false'},
      {id: 1, label: 'Yes', value: 'true'}
    ];

    const propMaster = {
      productType: product_type,
      category: product_categories,
      subCategory: product_sub_categories,
      subSubCategory: product_categories_lev3,
      isChargeTaxes: yesNoSelect,
      isRequireShip: yesNoSelect,
      isNewArrived: yesNoSelect
    };

    const renderOptions = (prop) => {
      let arr = propMaster[prop];
      if (Boolean.indexOf(prop) === -1) {
        arr = [{id: 'null', label: '', value: 'null'}, ...orderBy(toSelectData(propMaster[prop]), ['label'],['asc'])];
      }
      return arr.map((item, index) => {
        return (
          <option key={`${prop}${index}${item.id}`} value={item.id}>{item.label}</option>
        )
      })
    };

    return (<form className="block-content">
      <h4 className="block-content__title">
        <i className="fa fa-pencil" aria-hidden="true"> </i>
        Edit PRODUCT information
      </h4>
      <div className="row">
        {
          propertyProduct.map((property, index) => {
            let element;

            if (property === 'description') {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <textarea
                  className="form-control"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  defaultValue={this.state.current[property] || ''}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </div>
            } else if (Number.includes(property)) {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <input
                  type="number"
                  className="form-control"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  defaultValue={this.state.current[property] || ''}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </div>
            } else if (Select.includes(property)) {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <select
                  id={"nf-" + property}
                  name={"nf-" + property}
                  className="form-control"
                  defaultValue={this.state.current[property]}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                  placeholder={v.capitalize(property)}
                >
                  {renderOptions(property)}
                </select>
              </div>
            } else if (Boolean.includes(property)) {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <select
                  id={"nf-" + property}
                  name={"nf-" + property}
                  className="form-control"
                  defaultValue={this.state.current[property] == true ? 1 : 0}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                  placeholder={v.capitalize(property)}
                >
                  {renderOptions(property)}
                </select>
              </div>
            } else if (ListType.includes(property)) {
              const dv = Array.isArray(this.state.current[property]) ? this.state.current[property].join(",") : '';
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)} (*)</label>
                <input
                  type="text"
                  className="form-control"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  defaultValue={dv}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </div>;
            } else {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <input
                  type="text"
                  className="form-control"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  defaultValue={this.state.current[property] || ''}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </div>;
            }

            return (
              <div className="col-md-6" key={"property" + index}>
                {element}
              </div>
            );
          })
        }
      </div>
      <p className="text-warning">(*) multiple values, using "," to separate each value.</p>
    </form>)
  };

  renderDetail() {
    const { current } = this.state;
    let listImages = [];

    if (!! current && current.hasOwnProperty('images')) {
      const newList = current.images.slice();
      for (let i = 0; i < newList.length; i++) {
        if (!!newList[i]) {
          const item = {
            src: VarHelper.img(newList[i]),
            altText: '',
            caption: '',
          };
          listImages.push(item);
        }
      }
    }

    return (
      <div className="block-content product-detail">
        <div className="row">
          <div className="col-md-5">
            {/*images*/}
            <div>
              {listImages.length > 1 ? <Carousel items={listImages}/> : ''}
              {listImages.length === 1 ? <div className="product-image"><img src={listImages[0].src} alt=""/></div> : ''}
            </div>
          </div>
          <div className="col-md-7">
            <h4>{current.name}</h4>
            <div className="product__price">
              <h5 className="text text-success">{VarHelper.textMoney(current.price)} vnd</h5>
              <del className="text-muted">{VarHelper.textMoney(current.comparePrice)} vnd</del>
            </div>
            {current.quality ? <h6 className="text-success">{current.quality } items left</h6> : <h6 className="text-danger">Out of stock</h6>}
            <p>{current.description}</p>
            <p>Vendor - {current.vendor}</p>
            <p>Sell - {current.numberOfSell}</p>
            <p>Category - {current.category}</p>
          </div>
        </div>
      </div>
    )
  };

  handleAddReview = async (e) => {
    !!e && e.preventDefault();
    const { review, current } = this.state;
    const { userStore, ratingStore } = this.props;
    const payload = {
      star: review.star,
      content: review.content,
      subjectId: userStore.userData.id,
      subjectType: 'user',
      objectId: current.id,
      objectType: 'product',
    };
    this.setState({isAdding: true});
    const res = await ratingStore.create(payload);
    this.setState({isAdding: false});
    console.log(res);
    console.log([res.data, ...this.state.reviewList]);
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    window.toast.info('Added successfully!');
    this.setState({reviewList: [res.data, ...this.state.reviewList]});
  };

  handleCancelAddReview = (e) => {
    !!e && e.preventDefault();
    const { review } = this.state;
    if (isEmpty(review)) {
      this.setState({enableAddNew: false});  return null;
    }
    if (window.confirm("Are you sure want to cancel?")) {
      this.setState({enableAddNew: false, review: {}});
    }
  };

  renderAddReview = () => {
    const {isAdding} = this.state;
    return (
      <div className="card add-new-review">
        <div className="card-header">
          <h6>Add new review</h6>
        </div>
        <div className="card-body">
          <label>Star</label>
          <select className="form-control" onChange={(e) => {
            const value = parseInt(e.target.value);
            this.setState({review: {...this.state.review, star: value}})
          }}>
            <option value={0}> </option>
            <option value={1}>1 star</option>
            <option value={2}>2 stars</option>
            <option value={3}>3 stars</option>
            <option value={4}>4 stars</option>
            <option value={5}>5 stars</option>
          </select>
          <br/>
          <label>Content</label>
          <textarea className="form-control" style={{height: '128px'}} onChange={(e) => this.setState({review: {...this.state.review, content: e.target.value}})}>
          </textarea>
        </div>
        <div className="card-footer">
          <button className="btn btn-sm btn-primary" disabled={isAdding} onClick={e => this.handleAddReview(e)}><i className="fa fa-dot-circle-o"></i> {isAdding ? 'Submitting...':'Submit'}</button>
          <button className="btn btn-sm btn-default" onClick={(e) => this.handleCancelAddReview(e)}>Cancel</button>
        </div>
      </div>
    )
  };

  handleEditReview = (e, index) => {
    !!e && e.preventDefault();
    let {reviewList} = this.state;
    reviewList.map((item, idx) => {
      if (index === idx) {
        item.editing = true;
      }
      return item;
    });
    this.setState({reviewList});
  };

  handleUpdateReview = async (e, index) => {
    !!e && e.preventDefault();
    const { ratingStore } = this.props;
    let { reviewList } = this.state;
    const item = reviewList.find((itm, idx) => idx === index);
    const payload = {
      id: item.id,
      star: item.star,
      content: item.content
    };

    reviewList.map((itm, idx) => {
      if (idx === index) itm.updating = true;
    });

    this.setState({reviewList});
    const res = await ratingStore.update(payload);
    reviewList.map((itm, idx) => {
      if (idx === index) itm.updating = false;
    });
    this.setState({reviewList});

    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    reviewList.map((itm, idx) => {
      if (idx === index) itm.editing = false;
    });
    this.setState({reviewList});
    return window.toast.info("Updated successfully!");
  };

  handleDeleteReview = async (e, index) => {
    !!e && e.preventDefault();
    const { ratingStore } = this.props;
    let { reviewList } = this.state;
    const item = reviewList.find((itm, idx) => idx === index);

    if (!window.confirm("Are you sure want to delete " + (item.createdByUser.name || 'unknown'))) {
      return null;
    }

    reviewList.map((itm, idx) => {
      if (idx === index) itm.deleting = true;
    });

    this.setState({reviewList});
    const res = await ratingStore.delete({id: item.id});
    reviewList.map((itm, idx) => {
      if (idx === index) itm.deleting = false;
    });
    this.setState({reviewList});

    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    reviewList = reviewList.filter((itm, idx) => index !== idx);
    this.setState({reviewList});
    return window.toast.info("Deleted successfully!");
  };

  handleCancelEditReview = (e, index) => {
    !!e && e.preventDefault();
    let {reviewList} = this.state;
    reviewList.map((item, idx) => {
      if (index === idx) {
        item.editing = false;
      }
      return item;
    });
    this.setState({reviewList});
  };

  handleOnChangeReview = (label, value, index) => {
    const { reviewList } = this.state;
    reviewList.map((item, idx) => {
      if (index === idx) item[label] = value;
      return item;
    });
    this.setState({reviewList});
  };

  renderReview = (item = {}, index) => {
    if (!!item.editing) {
      return (
        <div className="review-item" key={'review' + index}>
          <div className="media">
            <div className="media-left" style={{marginRight: '16px'}}>
              <img src={!!item.createdByUser ? item.createdByUser.avatar : defaultImage} alt="" className="media-object img-circle" style={{width: '45px'}} />
            </div>
            <div className="media-body">
              <select className="form-control" value={item.star} onChange={(e) => {
                const value = parseInt(e.target.value);
                this.handleOnChangeReview('star', value, index);
              }}>
                <option value={0}> </option>
                <option value={1}>1 star</option>
                <option value={2}>2 stars</option>
                <option value={3}>3 stars</option>
                <option value={4}>4 stars</option>
                <option value={5}>5 stars</option>
              </select>
              <br/>
              <h5 className="media-heading">{!!item.createdByUser ? item.createdByUser.name : 'Anonymous'}</h5>
              <textarea className="form-control" value={item.content} style={{height: '128px', marginBottom: '16px'}} onChange={(e) => {
                this.handleOnChangeReview('content', e.target.value, index);
              }}>
              </textarea>
              <div className="button-group">
                <button className="btn btn-sm btn-primary" disabled={!!item.updating} onClick={e => this.handleUpdateReview(e, index)}><i className="fa fa-dot-circle-o"></i> {!!item.updating ? 'Saving...':'Save'}</button>
                <button className="btn btn-sm btn-default" onClick={e => this.handleCancelEditReview(e, index)}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="review-item" key={'review' + index}>
        <div className="media">
          <div className="media-left" style={{marginRight: '16px'}}>
            <img src={!!item.createdByUser ? item.createdByUser.avatar : defaultImage} alt="" className="media-object img-circle" style={{width: '45px'}} />
          </div>
          <div className="media-body">
            <h6>{item.star} star</h6>
            <h5 className="media-heading">{!!item.createdByUser ? item.createdByUser.name : 'Anonymous'}</h5>
            <p>{item.content}</p>
            <div className="button-group">
              <button className="btn btn-sm btn-primary" onClick={e => this.handleEditReview(e, index)}><i className="fa fa-pencil"></i> Edit</button>
              <button className="btn btn-sm btn-danger" disabled={!!item.deleting} onClick={e => this.handleDeleteReview(e, index)}> {!!item.deleting ? 'Deleting...':'Delete'}</button>
            </div>
          </div>
        </div>
      </div>
    )
  };

  renderReviewSection = () => {
    const { reviewList, enableAddNew } = this.state;
    return (
      <div className="block-content">
        <h3 className="block-content__title">Reviews ({reviewList.length})</h3>
        <div className="block-content__body">
          <div className="block-content__body--header" style={{marginBottom: '24px'}}>
            <div style={{marginBottom: '24px'}}>
              <button className="btn btn-sm btn-primary"
                      onClick={() => this.setState({enableAddNew: true})}
              >
                <i className="fa fa-plus"> </i> Add new</button>
            </div>
            {enableAddNew ? this.renderAddReview() : ''}
          </div>
          <div className="block-content__body--list">
            {
              reviewList.slice().map((item, index) => this.renderReview(item, index))
            }
          </div>
        </div>
      </div>
    )
  };

  render() {
    const { isLoading, openImageModal, enableEdit, isSaving, current } = this.state;
    const { routeStore } = this.props;
    if (isLoading) return (<Loading> </Loading>);
    if (enableEdit) {
      return (
        <div className="animated fadeIn" id="product-detail">
          {this.renderApprove()}
          <div className="card">
            <div className="card-header">
              <div className="card-header-left">
                <span><i className="fa fa-envelope-open"> </i> {current.name}</span>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-7">
                  {this.renderFormEdit()}
                </div>
                <div className="col-md-5">
                  {this.renderUploadForm()}
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="button-group">
                <button className="btn btn-sm btn-primary" disabled={isSaving} onClick={this.saveChanges}>
                  <i className="fa fa-dot-circle-o"> </i> { isSaving ? 'Saving' : 'Save' }
                </button>
                <button className="btn btn-sm btn-danger" onClick={this.cancelEdit}>
                  <i className="fa fa-ban"> </i> Cancel
                </button>
              </div>
            </div>
          </div>
          <UploadImageModal
            open={openImageModal}
            list={current.images}
            onClose={this.handleCloseModal}
            onSubmit={this.handleSubmitModal}
          >
          </UploadImageModal>
        </div>
      )
    }

    return (
      <div className="animated fadeIn" id="product-detail">
        {this.renderApprove()}
        <div className="card">
          <div className="card-header">
            <div className="card-header-left">
              <span><i className="fa fa-envelope-open"> </i> {current.name}</span>
            </div>
            <div className="card-header-right">
              <div className="button-group">
                <a target="_blank" href={routeStore.web.productDetail(current.id, current.name)}>
                  <button className="btn btn-sm btn-primary" style={{ marginRight: 10 }}>
                    <i className="fa fa-chrome"> </i> Mở bên web
                  </button>
                </a>
                <button className="btn btn-sm btn-primary" onClick={this.handleEnableEdit}>
                  <i className="fa fa-pencil" aria-hidden="true"> </i> Edit
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            {this.renderDetail()}
            <div className="row">
              <div className="col-md-6">
                {this.renderCreator()}
              </div>
            </div>
            {this.renderReviewSection()}
          </div>
          <div className="card-footer">
            {this.renderApprove()}
            <button className="btn btn-sm btn-default" onClick={() => this.props.history.goBack()}>
              <i className="fa fa-long-arrow-left"> </i> Go back
            </button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Product/Detail.js